import { useQuery } from '@tanstack/react-query';

import { makeAPIRequestV2 } from '@/utils/api';

interface ReferralPdfInfo {
  imageUrls: string[];
  practiceId: number;
  unifiedAppointmentId: string;
  estimatedVisitId: string;
  patientFirstName?: string;
  patientLastName?: string;
  patientEmail?: string;
  patientPhone?: string;
  referralReason?: string;
  toothNumbers: string[];
  proceduresIds: number[];
  referralPracticeId?: number;
  referralSpecialistId?: number;
  narrative?: string;
  status: string;
  currentStep: number;
  createdAt: string;
  updatedAt: string;
  specialtyId?: number;
  specialtyName?: string;
  referralPracticeName?: string;
  referralPracticeLocId?: number;
  referralPracticeAddress?: string;
  referralPracticePhone?: string;
  referralSpecialistSpecId?: number;
  procedures: any[];
  analyses: any[];
  patientDateOfBirth?: string;
  practiceEmail?: string;
  doctorFirstName?: string;
  doctorLastName?: string;
  doctorPhone?: string;
}

export const useReferralPdfInfo = (
  identifier: string,
  options?: { enabled?: boolean; useReferralId?: boolean },
) => {
  const useReferralId = options?.useReferralId ?? false;
  
  return useQuery({
    queryKey: ['referralPdfInfo', identifier, useReferralId ? 'referralId' : 'unifiedAppointmentId'],
    queryFn: async (): Promise<ReferralPdfInfo> => {
      const endpoint = useReferralId
        ? `/referrals/by-referral-id/${identifier}/pdf-info`
        : `/referrals/${identifier}/pdf-info`;
      
      const response = await makeAPIRequestV2(endpoint);
      return response.data;
    },
    enabled: options?.enabled ?? !!identifier,
  });
};
